/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

(function(){
  var p='/products/chequier-damour-imprime-et-envoye';
  if (location.pathname.indexOf(p)===-1) return;
  function go(){
    if (document.getElementById('atoi-reassurance')) return;
    var form=document.querySelector('#product_form_10833524457805') || document.querySelector('form.ProductForm');
    if(!form) return;
    var btn=form.querySelector('[type="submit"]');
    var box=document.createElement('ul');
    box.id='atoi-reassurance';
    box.setAttribute('aria-label','Reassurance');
    box.style.cssText='list-style:none;margin:12px 0 0;padding:0;font-size:13px;line-height:1.6;color:#5c4a3a';
    box.innerHTML='<li>✓ Paiement sécurisé</li><li>✓ Expédition suivie</li><li>✓ Cadeau original</li><li>✓ Personnalisation disponible</li>';
    if(btn&&btn.parentNode) btn.parentNode.insertBefore(box, btn.nextSibling); else form.appendChild(box);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', go); else go();
})();
